import React from 'react';
import UserAvatar from './UserAvatar';
import UserInfo from './UserInfo';
import styles from './UserDisplay.module.css';

export interface UserCardProps {
  avatarUrl?: string | null;
  name: string;
  email?: string | null;
  size?: number;
  className?: string;
}

const UserCard: React.FC<UserCardProps> = ({ 
  avatarUrl, 
  name, 
  email,
  size = 40,
  className = '' 
}) => {
  return (
    <div className={`${styles.userCard} ${className}`}>
      <UserAvatar avatarUrl={avatarUrl} name={name} size={size} />
      <UserInfo name={name} email={email} />
    </div>
  );
};

export default UserCard;

